import { render, staticRenderFns } from "./AddCourseSEO.vue?vue&type=template&id=2d2a00c1&scoped=true"
import script from "./AddCourseSEO.vue?vue&type=script&lang=js"
export * from "./AddCourseSEO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2a00c1",
  null
  
)

export default component.exports